import { Box, Skeleton, Theme } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

import { ListingCardLoading } from "../listings/ListingCard";

export function MobileCardsLoading({ cards = 3 }: { cards?: number }) {
  return (
    <Box sx={{ margin: "auto" }}>
      {[...Array(cards).keys()].map(index => (
        <Box
          key={index}
          sx={{
            margin: "0 auto"
          }}
        >
          <Skeleton
            variant="rectangular"
            height={"203px"}
            sx={{ marginY: "1em", marginX: ".5em", borderRadius: "10px" }}
          />
        </Box>
      ))}
    </Box>
  );
}

export function CuratedDesktopCardsLoading({
  cards = 8,
  sx,
  isTutoringCLP = false
}: {
  cards?: number;
  sx?: SystemStyleObject;
  isTutoringCLP?: boolean;
}) {
  return (
    <Container sx={{ ...sx }}>
      <Box
        sx={(theme: Theme) => ({
          margin: "auto",
          display: "grid",
          gridTemplateColumns: isTutoringCLP
            ? "repeat(auto-fit, 500px)"
            : "repeat(auto-fit, 242px)",
          gridTemplateRows: `repeat(2, auto)`,
          gridAutoRows: "0px",
          gridColumnGap: "20px",
          gridRowGap: "20px",
          justifyContent: "space-between",
          overflow: "hidden",
          [theme.breakpoints.only("md")]: {
            justifyContent: "space-around"
          }
        })}
      >
        {[...Array(cards).keys()].map(el => (
          <ListingCardLoading key={el} isTutoringCLP={isTutoringCLP} />
        ))}
      </Box>
    </Container>
  );
}

export function ActivityGridLoadingState({
  cards = 6,
  includeHeading = true,
  sx,
  isTutoringCLP = false
}: {
  cards?: number;
  includeHeading?: boolean;
  sx?: SystemStyleObject;
  isTutoringCLP?: boolean;
}) {
  const isMobile = useIsMobile();
  const childComponent = isMobile ? (
    <MobileCardsLoading cards={cards} />
  ) : (
    <CuratedDesktopCardsLoading cards={4} isTutoringCLP={isTutoringCLP} />
  );

  return (
    <Container sx={{ ...sx }}>
      {includeHeading && (
        <Box sx={{ margin: 20 }}>
          <Skeleton variant="text" height={45} width={350} />
          <Skeleton variant="text" height={34} width={300} />
        </Box>
      )}
      {childComponent}
    </Container>
  );
}
